import { useEffect, useState } from 'react';

const useLocalStorageList = (localStorageKey = '') => {
    const [list, setList] = useState([]);

    useEffect(() => {
        try {
            const localStorageList = JSON.parse(localStorage.getItem(localStorageKey)) || [];

            setList(localStorageList);
        } catch {
            setList([]);
        }
    }, [localStorageKey]);

    const handleAddItem = (item) => {
        const newList = [
            item,
            ...list,
        ];

        setList(newList);

        localStorage.setItem(localStorageKey, JSON.stringify(newList));
    };

    const handleClearList = () => {
        setList([]);

        localStorage.setItem(localStorageKey, JSON.stringify([]));
    };

    return {
        list,
        handleAddItem,
        handleClearList,
    };
};

export default useLocalStorageList;
